import React from "react";
import ReactDOM from "react-dom";
import { connect } from 'react-redux';
import store from "../../store";
import {
    DrawerFichaImpresionDocumento
} from "../../action/actionCreators";
import { ObtenerReglasAlmacenesAlternativosSocioEnAPI, ModificarReglasAlmacenesAlternativosSocioEnAPI } from "../../action/actionCreatorsRequests";
import {
    diaPorNumero,
    traducirPagina, MSGOK, obtenerToken, recortarCadena, obtenerUsuario

} from "../../librerias/funciones"

import FichaImpresion from '../../components/Sertec/FichaImpresionDocumento'
import { Select } from 'antd';
import {
    PlusOutlined,
    PrinterOutlined,
    EditOutlined,
    DeleteOutlined

} from '@ant-design/icons';
import { Layout } from 'antd';
import FichaManteniminetoRegla from "./FichaManteniminetoRegla.jsx";
const { Content } = Layout;
const { Option } = Select;

const ReglasAlm = ({ }) => {
    const [alturaSubmenu, setAlturaSubmenu] = React.useState(0);
    const ref = React.useRef(null)

    const [reglasAlmacenes, setReglasAlmacenes] = React.useState([]);
    const [reglasAlmacenesAux, setReglasAlmacenesAux] = React.useState([]);
    const [sociosLocal, setSociosLocal] = React.useState([]);
    const [abrirFichaRegla, setAbrirFichaRegla] = React.useState(false);
    const [socioSeleccionado, setSocioSeleccionado] = React.useState(0);
    const [usuarioSeleccionado, setUusuarioSeleccionado] = React.useState({});
    const [loaderTabla, setLoaderTabla] = React.useState(false);


    const obtenerReglasAlmacenes = (ORDERCOLUM, ORDERDIR, ID_SOCIO, ID, ALMACEN) => {
        setReglasAlmacenes([])
        setReglasAlmacenesAux([])
        setLoaderTabla(true)

        ObtenerReglasAlmacenesAlternativosSocioEnAPI(ORDERCOLUM, ORDERDIR, ID_SOCIO, ID, ALMACEN).then((reglas) => {
            setLoaderTabla(false)

            if (reglas !== undefined) {
                if (reglas.REGISTROS !== null && reglas.REGISTROS.length > 0) {
                    setReglasAlmacenes(reglas.REGISTROS)
                    setReglasAlmacenesAux(reglas.REGISTROS)
                } else {
                    setReglasAlmacenes(null)
                    setReglasAlmacenesAux(null)
                }
            }

        })
    }


    const DarDeBajaUsuario = (payLoadLocal) => {
        ModificarReglasAlmacenesAlternativosSocioEnAPI(2, payLoadLocal).then(usuario => {
            if (usuario !== undefined) {
                if (usuario.OK) {
                    MSGOK("Regla eliminada correctamente")

                    obtenerReglasAlmacenes(1, "A", socioSeleccionado, "", "")


                }
            }
        })

    }




    React.useEffect(() => {
        if (ref.current !== null) {
            setAlturaSubmenu(ref.current.clientHeight)
        }
    })



    React.useEffect(() => {
        if (obtenerToken() !== undefined) {
            let accesoLicencia = obtenerUsuario();
            setSociosLocal(accesoLicencia.SOCIOS)
            obtenerReglasAlmacenes(1, "A", accesoLicencia.SOCIOS[0].ID_SOCIO, "", "")
            setSocioSeleccionado(accesoLicencia.SOCIOS[0].ID_SOCIO)
        }
    }, [])



    document.getElementById("tituloMenu") !== null && ReactDOM.render(
        <>
            {`SERTEC - ${traducirPagina("Reglas_sustitucion").toUpperCase()}`}
        </>,
        document.getElementById("tituloMenu")
    );


    return (
        <div>
            <div className="menu_mantenimiento" ref={ref}>
                <div className="mantenimiento_item1" style={{ gap: '10px' }}></div>

                <div className="mantenimiento_item2" style={{ gap: '10px' }}>
                    {sociosLocal !== null ?

                        <Select
                            showSearch
                            allowClear={obtenerUsuario().SOCIOS.length > 1 ? true : false}
                            defaultValue={obtenerUsuario().SOCIOS[0].ID_SOCIO}
                            size={"large"}
                            placeholder={traducirPagina("Seleccione_socio")}
                            style={{ width: "250px", textAlign: 'left' }}
                            optionFilterProp="children"
                            onChange={(e) => {
                                if (e === undefined || e === null) {
                                    setReglasAlmacenes(null)
                                } else {
                                    setSocioSeleccionado(parseInt(e));
                                    obtenerReglasAlmacenes(1, "A", e, "", "")
                                    //licenciasSertec(1, "A", e);
                                }
                            }}
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {sociosLocal.length > 0 ?
                                sociosLocal.map((socio) =>
                                    <Option key={socio.ID_SOCIO} value={socio.ID_SOCIO}>{socio.NOMBRE_SOCIO}</Option>
                                )
                                :
                                null
                            }
                        </Select>


                        :
                        <div style={{ textAlign: 'center' }}>
                            <h4>{traducirPagina("Info_error_socio")}</h4>
                        </div>
                    }


                    <div className="grid-container" style={{ backgroundColor: '#eee', padding: '0px' }}>
                        <div className="grid-item">
                            <button className="btn_buscador_tarifa"
                                style={{ backgroundColor: '#fff', color: '#00468e', borderRadius: '0px 5px 5px 0px' }}
                                onClick={() => {
                                    store.dispatch(DrawerFichaImpresionDocumento(true));
                                }}
                            >
                                <PrinterOutlined style={{ fontSize: '20px' }} />
                            </button>
                        </div>
                    </div>


                    <div className="botonNuevo" style={{ backgroundColor: 'var(--azul-claro-serca)', color: '#fff' }} onClick={() => {
                        setAbrirFichaRegla(true);
                        setUusuarioSeleccionado({})
                    }}>
                        <PlusOutlined /> {traducirPagina("Nueva_regla")}
                    </div>
                </div>
            </div>


            <div className="margen_tabla">
                {reglasAlmacenes === null ?
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}>
                        <h4>
                            {traducirPagina("Sin_reglas_Almacenes")}
                        </h4>
                    </div>
                    :
                    reglasAlmacenes.length > 0 ?
                        <div className="container_tabla_generico" style={{ height: `calc(100vh - ${(120 + alturaSubmenu)}px )` }} >
                            <table style={{ border: '1px solid #d9d9d9', width: '100%' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#e0e0e0' }}>
                                        <th style={{ width: '60px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}> {traducirPagina("ID")}  </th>
                                        <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}  > {traducirPagina("Nombre")} </th>

                                        <th style={{ width: '170px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}  > {traducirPagina("Almacen")} </th>
                                        <th style={{ width: '170px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}  > {traducirPagina("Alm_alternativo")} </th>
                                        <th style={{ width: '170px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}  > {traducirPagina("Repeticion")} </th>

                                        <th style={{ width: '170px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} > {traducirPagina("Dia_creacion")}</th>
                                        <th style={{ width: '170px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} > {traducirPagina("Fecha")}  </th>
                                        <th style={{ width: '80px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} > </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reglasAlmacenes.map((regla) =>
                                        <tr key={regla.ID} style={{ backgroundColor: '#fff' }}>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} title={regla.ID}>{regla.ID}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} title={regla.NOMBRE_EMPRESA}>{recortarCadena(regla.NOMBRE_EMPRESA, 20, "...")}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{regla.ALMACEN}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{regla.ALMACEN_ALTERNATIVO}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{regla.REPETICION === 0 ? "SI" : "NO"}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{diaPorNumero(regla.DIA_REPETICION)}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{regla.FECHA_UNICA}</td>

                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>
                                                <div className="flex-container-Grow-Simple">
                                                    <div style={{ margin: '0px 2px' }}>

                                                        <button title={"Modificar"} onClick={() => {
                                                            setUusuarioSeleccionado(regla);
                                                            //setAbrirFichaMostrador(true);
                                                            setAbrirFichaRegla(true)
                                                        }}
                                                            className="btn-matricula  estiloBotonRemove paddindDeTres">
                                                            <EditOutlined style={{ cursor: 'pointer', fontSize: '20px', color: '#000' }} />
                                                        </button>

                                                    </div>



                                                    <div style={{ margin: '0px 2px' }} >
                                                        <button title={"Dar de baja"} onClick={() => {

                                                            DarDeBajaUsuario(regla)
                                                        }}
                                                            className="btn-matricula  estiloBotonRemove paddindDeTres">
                                                            <DeleteOutlined style={{ cursor: 'pointer', fontSize: '20px', color: '#000' }} />
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                    }
                                </tbody>
                            </table>
                        </div>
                        :
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                }
            </div>



            <FichaImpresion title={traducirPagina("Impresion_doc").toUpperCase()} LICENCIAS={reglasAlmacenes}></FichaImpresion>
            {abrirFichaRegla ?
                <FichaManteniminetoRegla title={traducirPagina("Regla_sustitucion_alm")}
                    ESTADO_FICHA={abrirFichaRegla}
                    CERRAR_FICHA={setAbrirFichaRegla}
                    ID_SOCIO={socioSeleccionado}
                    ACTUALIZAR_REGLAS={obtenerReglasAlmacenes}
                    SELECCIONADO={usuarioSeleccionado}
                    MODIFICAR_SELECCIONADO={setUusuarioSeleccionado}
                >
                </FichaManteniminetoRegla>
                :
                null
            }
        </div>
    );
}

const mapStateToProps = state => {
    return {
        configApp: state.configApp,
    };
}

export default connect(mapStateToProps)(ReglasAlm);

